"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7216],{

/***/ 33676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ AccordionWithImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_Icon_IconArrow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16983);
/* harmony import */ var components_Icon_IconArrowDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26178);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41272);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51776);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86880);
/* harmony import */ var components_Icon_IconAngle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58682);
/* harmony import */ var modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40474);
/* harmony import */ var components_Icon_IconLesson__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35445);
/* harmony import */ var components_Image_Image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72317);











const AccordionWithImage = ({ title , description , eventName ="" , eventProperties ={} , index =0 , length =0 , isSeparated =false , className ="" , data , countLesson =0  })=>{
    const loginState = (0,modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_8__/* .useAuthStore */ .t)((state)=>state.loginState);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const contentScrollRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const [currentScrollLeft, setCurrentScrollLeft] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [currentScrollWidth, setCurrentScrollWidth] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [currentContainerWidth, setCurrentContainerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [currentContainerHeight, setCurrentContainerHeight] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0);
    const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("common");
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (contentScrollRef.current) {
            setCurrentScrollLeft(contentScrollRef.current.scrollLeft);
            setCurrentScrollWidth(contentScrollRef.current.scrollWidth);
            setCurrentContainerWidth(contentScrollRef.current.clientWidth);
            setCurrentContainerHeight(contentScrollRef.current.clientHeight);
            // @ts-ignore
            contentScrollRef.current.addEventListener("scroll", ()=>{
                setCurrentScrollLeft(contentScrollRef.current.scrollLeft);
            });
        }
    }, [
        contentScrollRef.current
    ]);
    const toggleExpanded = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(()=>{
        setExpanded((current)=>{
            const status = !current ? "open" : "close";
            const eventprops = {
                ...eventProperties,
                dropdown_name: title,
                state: status
            };
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                event: eventName,
                property: eventprops
            });
            return !current;
        });
    }, [
        eventName,
        eventProperties,
        title
    ]);
    let images = data[0]?.image ?? null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `relative py-12 px-16 cursor-pointer bg-white ${className} ${isSeparated ? "rounded-16 border border-neutral20_to_dark30" : index == 0 && length == 1 ? "rounded-16" : index == 0 && length > 1 ? "rounded-t-16" : index == length - 1 ? "rounded-b-16" : ""}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-left relative items-center select-none flex justify-between flex-row",
                onClick: toggleExpanded,
                children: [
                    expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                        className: "font-b1 font-medium text-left flex items-center pl-4",
                        children: [
                            t("totalLesson", {
                                count: countLesson,
                                additionalS: data?.length > 1 ? "s" : ""
                            }),
                            " ",
                            t("thisCourse")
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-8 align-center",
                        children: [
                            images ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "rounded-8 bg-white flex",
                                children: expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[172px] h-[96px] z-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Image_Image__WEBPACK_IMPORTED_MODULE_10__.Image, {
                                        src: images,
                                        alt: "images",
                                        width: 172,
                                        height: 96,
                                        className: "rounded-8"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[92px] h-[52px] z-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Image_Image__WEBPACK_IMPORTED_MODULE_10__.Image, {
                                                src: images,
                                                alt: "images",
                                                width: 92,
                                                height: 52,
                                                className: "rounded-8"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[92px] h-[52px] absolute top-0 z-4",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Image_Image__WEBPACK_IMPORTED_MODULE_10__.Image, {
                                                src: images,
                                                alt: "images",
                                                width: 92,
                                                height: 52,
                                                className: "rounded-8"
                                            })
                                        })
                                    ]
                                })
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                className: `font-b1 font-medium text-left flex items-center ${countLesson > 1 ? "ml-16" : ""}`,
                                children: t("totalLesson", {
                                    count: countLesson,
                                    additionalS: data?.length > 1 ? "s" : ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-none pl-2",
                        children: expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconArrow__WEBPACK_IMPORTED_MODULE_1__/* .IconArrow */ .C, {
                            isCaret: true,
                            direction: "up"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconArrowDown__WEBPACK_IMPORTED_MODULE_2__/* .IconArrowDown */ .B, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `overflow-x-scroll relative flex gap-8 duration-500 transition-[max-height] ease-out ${expanded ? "max-h-[220px]" : "max-h-0"}`,
                        ref: contentScrollRef,
                        children: data.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                        className: `text-b2 px-4 font-medium text-left flex items-center mt-8 ${item.lessons.length === 1 ? "w-[170px] line-clamp-1" : "line-clamp-1"}`,
                                        children: item.name ?? `Chapter ${index + 1}`
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex gap-8 font-light",
                                        children: item.lessons.map((lesson)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "grid gap-2 hover:bg-purple-20 p-4 rounded-8",
                                                onClick: ()=>{
                                                    router.push(loginState == "LOGIN" ? {
                                                        pathname: "/course/[courseSlug]",
                                                        query: {
                                                            courseSlug: lesson.course_slug,
                                                            lesson: lesson.slug
                                                        }
                                                    } : {
                                                        pathname: "/login",
                                                        query: {
                                                            url: encodeURIComponent(`/course/${lesson.course_slug}&lesson=${lesson.slug}`)
                                                        }
                                                    });
                                                },
                                                children: [
                                                    expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: `w-[172px] h-[96px] z-0 mb-4 flex justify-center items-center rounded-8 ${[
                                                            "Video",
                                                            "AWS",
                                                            "IFrame",
                                                            "SCORM"
                                                        ].includes(lesson.type) ? "" : "bg-white"}`,
                                                        children: [
                                                            "Video",
                                                            "AWS",
                                                            "IFrame",
                                                            "SCORM"
                                                        ].includes(lesson.type) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Image_Image__WEBPACK_IMPORTED_MODULE_10__.Image, {
                                                            src: lesson.image,
                                                            alt: "images",
                                                            width: 172,
                                                            height: 96,
                                                            className: "rounded-8"
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: `w-[172px] h-[96px] flex justify-center items-center rounded-8`,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "w-full bg-white bg-[url('/images/bg-lesson.png')] h-full rounded-8 bg-no-repeat bg-center bg-cover flex justify-center items-center",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "rounded-full w-[44px] p-8 aspect-square bg-white flex justify-center items-center",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconLesson__WEBPACK_IMPORTED_MODULE_9__/* .IconLesson */ .h, {
                                                                        type: lesson.type
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-[92px] h-[52px] z-0",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Image_Image__WEBPACK_IMPORTED_MODULE_10__.Image, {
                                                            src: lesson.image,
                                                            alt: "images",
                                                            width: 92,
                                                            height: 52,
                                                            className: "rounded-8"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "w-[172px] font-medium text-b2 text-neutral-80 truncate text-left",
                                                        children: lesson.name
                                                    }),
                                                    [
                                                        "Video",
                                                        "AWS",
                                                        "IFrame",
                                                        "SCORM"
                                                    ].includes(lesson.type) && lesson.duration && lesson.duration !== 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "text-c1 font-light text-neutral-50",
                                                        children: [
                                                            lesson.duration,
                                                            " ",
                                                            t("minutes")
                                                        ]
                                                    }) : null
                                                ]
                                            }))
                                    })
                                ]
                            }))
                    }),
                    currentScrollLeft > 0 && expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute left-[-36px] top-[72px] bg-white w-32 h-32 flex justify-center items-center rounded-full cursor-pointer shadow-navigation",
                        // style={{
                        //   // top: currentContainerHeight / 2 - 20,
                        //   top: 45 % currentContainerHeight,
                        // }}
                        onClick: (e)=>{
                            if (contentScrollRef.current) {
                                contentScrollRef.current.scroll({
                                    left: contentScrollRef.current.scrollLeft - 336,
                                    behavior: "smooth"
                                });
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconAngle__WEBPACK_IMPORTED_MODULE_7__/* .IconAngle */ .H, {})
                    }) : null,
                    currentScrollWidth > currentContainerWidth && expanded && currentScrollLeft < currentScrollWidth - currentContainerWidth ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute right-[-36px] top-[72px] bg-white w-32 h-32 flex justify-center items-center rounded-full cursor-pointer shadow-navigation",
                        // style={{
                        //   // top: currentContainerHeight / 2 - 20,
                        //   top: 45 % currentContainerHeight,
                        // }}
                        onClick: (e)=>{
                            if (contentScrollRef.current) {
                                contentScrollRef.current.scroll({
                                    left: contentScrollRef.current.scrollLeft + 336,
                                    behavior: "smooth"
                                });
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconAngle__WEBPACK_IMPORTED_MODULE_7__/* .IconAngle */ .H, {
                            direction: "right"
                        })
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 97216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var components_Chip_LogoChip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90768);
/* harmony import */ var lib_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99601);
/* harmony import */ var components_Icon_IconStar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28939);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86880);
/* harmony import */ var components_Chip_Chip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5867);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41272);
/* harmony import */ var lib_host__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35304);
/* harmony import */ var components_Accordion_AccordionWithImage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33676);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56562);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40474);
/* harmony import */ var components_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9978);
/* harmony import */ var components_Icon_IconCheckCircle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4110);
/* harmony import */ var modules_Business_Selection_cartStore__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(13084);
/* harmony import */ var components_Icon_IconPlusCircle__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(38445);
/* harmony import */ var components_Icon_IconPlayCircle__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14016);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(64078);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var components_InteractiveAvatar_avatarStore__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43085);
/* harmony import */ var modules_Tenant_modalSectionStore__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(820);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(67832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var modules_Home_homeStore__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(88727);
/* harmony import */ var lib_detectDeviceV2__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(70632);
/* harmony import */ var lib_ssr__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(11927);

























const VideoJS = next_dynamic__WEBPACK_IMPORTED_MODULE_18___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2544), __webpack_require__.e(9412), __webpack_require__.e(8289), __webpack_require__.e(1239), __webpack_require__.e(5491)]).then(__webpack_require__.bind(__webpack_require__, 57818)).then((mod)=>mod.VideoJS), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57818)
            ]
    },
    ssr: false
});
const CardCourseWithLesson = ({ label , isUncheck =false , isHide =false , className ="" , isRow =false , isMyClass =false , isSquare =false , tracker , wrapClass ="" , isRecommendPage =false , onClickFunction , isModal =false , ...props })=>{
    const [chapters, setChapters] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [countLesson, setCountLesson] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [isLoading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // Device hook
    const { isMobile , isTablet , isDesktop , isPortrait , width , height  } = (0,lib_detectDeviceV2__WEBPACK_IMPORTED_MODULE_23__/* .useDeviceDetect */ .d)();
    const institutionImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (props?.institution?.image_url) return props?.institution?.image_url;
        if (typeof props?.institution == "string" && (props?.institution).split("||").length > 1 && (props?.institution).split("||")[1].includes("https")) return (props?.institution).split("||")[1];
        if (typeof props?.institution == "object") return props?.institution?.image_url;
        return null;
    }, [
        props?.institution
    ]);
    const institutionName = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>props.institution?.name || props.institution?.split("||")[0] || "", [
        props.institution
    ]);
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("common");
    const isB2B = (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .useIsTenant */ .we)() || (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .useIsSubdomain */ .Do)();
    const isBusiness = !isB2B;
    const isGokAresTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .isGokAresURL */ .a7)(window.location.hostname);
    const isPpdsmAparaturTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .isPpsdmAparaturURL */ .JC)(window.location.hostname);
    const isMenpanTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .isMenpanURL */ .Z1)(window.location.hostname);
    const isWonderfulLearningTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .isWonderfulLearningURL */ .X$)(window.location.hostname);
    const isKemkesTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .isMenkesURL */ .yj)(window.location.hostname);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isRow && props?.chapters && props?.chapters.length) {
            setLoading(true);
            const newChapters = props?.chapters.map((el)=>{
                const allLesson = el?.lessons && el?.lessons.length ? el?.lessons.map((items)=>({
                        image: props?.image_cover_url,
                        course_slug: props.slug,
                        ...items
                    })) : [];
                return {
                    name: el.name,
                    image: props?.image_cover_url,
                    lessons: allLesson
                };
            });
            let counting = props?.chapters.flatMap((el)=>el?.lessons && el?.lessons.length);
            setCountLesson(counting.length);
            setChapters(newChapters);
            setLoading(false);
        }
    }, [
        props.chapters,
        isRow
    ]);
    const events = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            event: "course_hover_a",
            property: {
                course_name: props?.name ?? "",
                course_slug: props?.slug ?? "",
                section_name: label ?? "",
                institution_name: props?.institution_name ?? props.institution?.name ?? "",
                index: props?.index ?? 0,
                page: `B2B Homepage`
            }
        }), [
        props
    ]);
    const [isHovering, setIsHovered] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [videoURL, setVideoURL] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [timeout, setModalTimeout] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [videoTimeout, setVideoTimeout] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setVideoURL(props?.hover_content_url);
    }, [
        isHovering
    ]);
    const mouseEnterHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        timeout && clearTimeout(timeout);
        videoTimeout && clearTimeout(timeout);
        setModalTimeout(setTimeout(()=>{
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGTM */ .hk)({
                ...events
            });
        }, 3000));
        setVideoTimeout(setTimeout(()=>{
            setIsHovered(isHide ? false : true);
        }, 500));
    }, [
        events,
        isHide,
        timeout,
        videoTimeout
    ]);
    const mouseLeaveHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        timeout && clearTimeout(timeout);
        videoTimeout && clearTimeout(videoTimeout);
        setIsHovered(false);
    }, [
        timeout,
        videoTimeout
    ]);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const hasBusinessCourse = typeof router.query.hasBusinessCourse == "string" ? router.query.hasBusinessCourse : "false";
    const { loginState , currentUser  } = (0,modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_12__/* .useAuthStore */ .t)((state)=>({
            loginState: state.loginState,
            currentUser: state.currentUser
        }));
    const gaiaMultipleAccess = currentUser?.tenant !== undefined && [
        "gaia",
        "mega-insurance-moodle",
        "pupuk-indonesia",
        "injourney"
    ].includes((currentUser?.tenant)?.slug) || [
        "gaia",
        "mega-insurance-moodle",
        "pupuk-indonesia",
        "injourney"
    ].includes(currentUser?.referral);
    const tenantJpTracker = currentUser?.tenant !== undefined && [
        "ppsdmaparatur",
        "menpan",
        "wonderfullearning",
        "kemkes",
        "tapinkab",
        "bssn",
        "bkpsdm-bekasikota",
        // "maluku-gate",
        // "trenggalekkab",
        "bpsdm-sumbar",
        "bpsdm-sulsel",
        "bpsdm-jambi",
        "bpsdmdki",
        // "jambikota",
        // "muarojambikab",
        // "pesawarankab",
        "batam",
        "pusdiklat-komdigi",
        "pusdiklat-kemenkeu",
        "kemenperin",
        "kemenlh",
        "setneg",
        "kemlu",
        "Kemendag",
        "ekraf",
        "bappenas",
        "kemensos",
        "kemendagri",
        "kominfo",
        "kemendes",
        "kemenpora",
        "kemenpppa",
        "kementan",
        "kudagang",
        "atrbpn"
    ].includes((currentUser?.tenant)?.slug) || [
        "ppsdmaparatur",
        "menpan",
        "wonderfullearning",
        "kemkes",
        "tapinkab",
        "bssn",
        "bkpsdm-bekasikota",
        // "maluku-gate",
        // "trenggalekkab",
        "bpsdm-sumbar",
        "bpsdm-sulsel",
        "bpsdm-jambi",
        "bpsdmdki",
        // "jambikota",
        // "muarojambikab",
        // "pesawarankab",
        "batam",
        "pusdiklat-komdigi",
        "pusdiklat-kemenkeu",
        "kemenperin",
        "kemenlh",
        "setneg",
        "kemlu",
        "Kemendag",
        "ekraf",
        "bappenas",
        "kemensos",
        "kemendagri",
        "kominfo",
        "kemendes",
        "kemenpora",
        "kemenpppa",
        "kementan",
        "kudagang",
        "atrbpn"
    ].includes(currentUser?.referral);
    const isSectionPage = router && router.pathname == "/section/[sectionSlug]";
    const isMyClassPage = router && router.pathname == "/my-class";
    const isSearchPage = typeof router.query.q == "string" ? router.query.q : null;
    const updateCart = (0,modules_Business_Selection_cartStore__WEBPACK_IMPORTED_MODULE_15__/* .useCartStore */ .x)((state)=>state.updateCart);
    // let content = () => null;
    const lengthOfText = props?.skills?.length > 0 ? props?.skills?.slice(0, 2).flatMap((el)=>el.name).join(" ").length : null;
    let index = isRow ? lengthOfText <= 100 ? 3 : 2 : 1;
    let lengthOfSkill = props?.skills?.length > index ? props?.skills?.length - index : null;
    const hasUserPaid = props.is_paid;
    const hasCertificate = props.has_certificate;
    const hasPaywall = props.is_paywall_enabled === undefined ? true : props.is_paywall_enabled;
    const isCourseFinished = props.enrollment_progress?.finished === props.enrollment_progress?.total;
    const isEnterprisePlus = currentUser?.tenant !== undefined && [
        "Enterprise Plus",
        "Pro Plus",
        `Pro Custom (${currentUser?.referral})`
    ].includes((currentUser?.tenant)?.plan?.name);
    let content = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>videoURL ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoJS, {
            isHovering: isHovering,
            url: videoURL,
            handleInterrupt: ()=>{}
        }) : null, [
        videoURL,
        isHovering
    ]);
    const [isHoveringGaia, setIsHoveringGaia] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { setIsCourseTranscript , setCourseTranscript  } = (0,components_InteractiveAvatar_avatarStore__WEBPACK_IMPORTED_MODULE_19__/* .useAvatarStore */ .z)();
    const [setIsShow] = (0,modules_Tenant_modalSectionStore__WEBPACK_IMPORTED_MODULE_20__/* .useModalSectionStore */ .y)((state)=>[
            state.setIsShow
        ]);
    const { hideSlugs , setHideSlugs , setIsNewHide , populerCourses , isInternalSetneg  } = (0,modules_Home_homeStore__WEBPACK_IMPORTED_MODULE_22__/* .useHomeStore */ .o)((state)=>({
            hideSlugs: state.hideSlugs,
            setHideSlugs: state.setHideSlugs,
            setIsNewHide: state.setIsNewHide,
            populerCourses: state.populerCourses,
            isInternalSetneg: state.isInternalSetneg
        }));
    const handleRemoveFromHide = (slug)=>{
        try {
            const parsed = JSON.parse(hideSlugs);
            if (!Array.isArray(parsed)) {
                console.warn("hideSlugs is not an array, resetting...");
                return;
            }
            const filtered = parsed.filter((item)=>item !== slug);
            const updated = JSON.stringify(filtered);
            localStorage.setItem("hideSlugs", updated);
            setHideSlugs(updated);
            setIsNewHide(true);
        } catch (error) {
            console.error("Error handling remove:", error);
        }
    };
    function formatMinutesToHours(minutes) {
        if (minutes < 60) {
            return `${minutes}m`;
        }
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        if (remainingMinutes === 0) {
            return `${hours}h`;
        } else {
            return `${hours}h ${remainingMinutes}m`;
        }
    }
    const isPopuler = populerCourses && JSON.parse(populerCourses).includes(props?.slug);
    const subDomain = (0,lib_ssr__WEBPACK_IMPORTED_MODULE_24__/* .isBrowser */ .j)() ? (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .getSubDomain */ .ZC)(window.location.hostname) : null;
    const isSubdomainTenant = (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .useIsSubdomain */ .Do)();
    const referral = isSubdomainTenant ? currentUser?.referral || subDomain : subDomain === "mgmbosco" ? "gaji-c0000756" : currentUser?.referral;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (!isRow ? "cursor-pointer" : "") + " relative h-full w-full",
        onClick: onClickFunction ? onClickFunction : ()=>{
            handleRemoveFromHide(props?.slug);
            if (!isRow) {
                if (props.onSelect) {
                    updateCart(props);
                } else {
                    router.push(loginState == "LOGIN" ? {
                        pathname: "/course/[courseSlug]",
                        query: {
                            courseSlug: props?.slug,
                            ...label && {
                                label: label
                            },
                            ...isPopuler && {
                                badge: "populer"
                            },
                            personalization: isRecommendPage ? "true" : "false"
                        }
                    } : {
                        pathname: "/login",
                        query: {
                            url: encodeURIComponent(`/course/${props?.slug}`),
                            personalization: isRecommendPage ? "true" : "false"
                        }
                    });
                }
            }
            if (tracker) {
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGTM */ .hk)(tracker);
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `flex gap-8 h-fit ${isRow ? "flex-col w-full md:flex-row" : "flex-col"}`,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: `relative cursor-pointer overflow-hidden aspect-[16/9] ${isHovering ? "" : isSquare ? "" : "rounded-8"} ${isRow ? "md:w-[40%] w-full h-full" : `${wrapClass} h-[200px] md:h-full`}`,
                    onMouseEnter: mouseEnterHandler,
                    onMouseLeave: mouseLeaveHandler,
                    onClick: ()=>{
                        handleRemoveFromHide(props?.slug);
                        if (isRow) {
                            router.push(loginState == "LOGIN" ? {
                                pathname: "/course/[courseSlug]",
                                query: {
                                    courseSlug: props?.slug,
                                    ...label && {
                                        label: label
                                    },
                                    ...isPopuler && {
                                        badge: "populer"
                                    },
                                    personalization: isRecommendPage ? "true" : "false"
                                }
                            } : {
                                pathname: "/login",
                                query: {
                                    url: encodeURIComponent(`/course/${props?.slug}`),
                                    personalization: isRecommendPage ? "true" : "false"
                                }
                            });
                        }
                        if (tracker) {
                            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGTM */ .hk)(tracker);
                        }
                    },
                    children: [
                        (!isHovering || !props?.hover_content_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: props.image_cover_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_21___default()), {
                                priority: true,
                                fetchPriority: "high",
                                alt: props.name,
                                src: props.image_cover_url,
                                width: 305,
                                height: 150,
                                "data-testid": "card-featured_cover",
                                className: `object-cover w-full h-full object-center ${isHovering ? "" : isSquare ? "" : "rounded-8"}`
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `bg-neutral-20 w-full aspect-[16/9] ${isRow ? "h-full" : "md:full"} ${isSquare ? "" : "rounded-8"}`
                            })
                        }),
                        isBusiness && router.pathname == "/pilih-kursus" && !isUncheck && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute top-0 w-full h-full flex justify-end items-start p-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconPlusCircle__WEBPACK_IMPORTED_MODULE_16__/* .IconPlusCircle */ .O, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute top-0 w-full h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-full flex justify-center items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconPlayCircle__WEBPACK_IMPORTED_MODULE_17__/* .IconPlayCircle */ .U, {
                                    size: 45,
                                    classes: "m-auto",
                                    isBgCustomized: true
                                })
                            })
                        }),
                        isHovering && props?.hover_content_url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-full",
                            children: content()
                        }),
                        isHide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute top-0 bg-[#00000099] w-full h-full flex justify-center items-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-b1 font-black text-white",
                                children: "Khusus goKampus Business"
                            })
                        }),
                        isPopuler && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute top-8 left-8 flex items-start justify-start p-2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center justify-center gap-[4px] bg-[#F3F4F6] text-[#fff] px-[8px] py-[4px] rounded-[6px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[12px] font-[500] text-[#2F0F57]",
                                    children: "\uD83D\uDD25 Populer"
                                })
                            })
                        }),
                        props?.course_available_until && props?.course_available_until !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute top-8 right-8 flex items-start justify-end p-2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center gap-[4px] bg-[#FAE7EC] text-[#D0375C] px-[8px] py-[4px] rounded-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/warning.png",
                                        className: "w-[20px] h-[20px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-sm font-thin",
                                        children: t("endingSoon")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute bottom-8 right-8 w-full h-full flex justify-end items-end gap-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center justify-center gap-[4px] bg-[rgba(0,0,0,0.5)] text-[#fff] px-[8px] py-[4px] rounded-[6px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[12px] font-[500]",
                                    children: formatMinutesToHours(props?.duration)
                                })
                            })
                        })
                    ]
                }),
                isRow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: `flex flex-col gap-12 ${isSquare ? "w-[90%] mx-auto" : "w-full md:w-[60%]"}`,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `overflow-hidden ${!isHovering ? "rounded-b-12" : ""}`,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `gap-8 relative text-neutral80_to_dark10 items-center`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col justify-betweenm gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
                                            // @ts-ignore
                                            href: hasBusinessCourse === "true" ? "https://business.gokampus.com/hubungi-sales" : loginState == "LOGIN" ? {
                                                pathname: "/course/[courseSlug]",
                                                query: isSectionPage ? {
                                                    courseSlug: props?.slug,
                                                    institutionKey: `${props?.institution.slug}`,
                                                    hasBusinessCourse: props?.institution.is_business,
                                                    institutionName: `${props?.institution.name}||${props?.institution.image_url}`,
                                                    ...label && {
                                                        label: label
                                                    },
                                                    ...isPopuler && {
                                                        badge: "populer"
                                                    },
                                                    personalization: isRecommendPage ? "true" : "false"
                                                } : props?.is_institution_business ? {
                                                    courseSlug: props?.slug,
                                                    institutionKey: props?.institution,
                                                    hasBusinessCourse: props?.is_institution_business,
                                                    institutionName: `${props?.institution.name}||${props?.institution.image_url}`,
                                                    ...label && {
                                                        label: label
                                                    },
                                                    ...isPopuler && {
                                                        badge: "populer"
                                                    },
                                                    personalization: isRecommendPage ? "true" : "false"
                                                } : {
                                                    courseSlug: props?.slug,
                                                    ...label && {
                                                        label: label
                                                    },
                                                    ...isPopuler && {
                                                        badge: "populer"
                                                    },
                                                    personalization: isRecommendPage ? "true" : "false"
                                                }
                                            } : {
                                                pathname: "/login",
                                                query: isSectionPage ? {
                                                    url: encodeURIComponent(`/course/${props?.slug}?institutionKey=${props?.institution.slug}&hasBusinessCourse=${props?.institution.is_business}&institutionName=${props?.institution.name}||${props?.institution.image_url}`),
                                                    personalization: isRecommendPage ? "true" : "false"
                                                } : {
                                                    url: encodeURIComponent(`/course/${props?.slug}?institutionKey=${props?.institution}&hasBusinessCourse=${props?.is_institution_business}`),
                                                    personalization: isRecommendPage ? "true" : "false"
                                                }
                                            },
                                            passHref: hasBusinessCourse === "true",
                                            rel: hasBusinessCourse === "true" ? "noopener noreferrer" : "",
                                            target: hasBusinessCourse === "true" ? "_blank" : "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                className: `text-b1 font-medium max-w-full text-neutral-80 text-left ` + (isMyClassPage ? "line-clamp-1" : "line-clamp-2"),
                                                children: [
                                                    props.name,
                                                    " ",
                                                    (tenantJpTracker || isGokAresTenant) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "text-violet_main_to_dark_purple_surface",
                                                        children: [
                                                            "(",
                                                            props?.learning_hours,
                                                            " JP)"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, props?.name + index),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex gap-8 items-center",
                                            children: [
                                                institutionImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_LogoChip__WEBPACK_IMPORTED_MODULE_2__/* .LogoChip */ .E, {
                                                    image_url: institutionImage,
                                                    size: 36,
                                                    useResizeImage: true,
                                                    styles: "border border-neutral20_to_dark30"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "grid gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-b2 font-light max-w-full truncate text-neutral80_to_dark10 text-left",
                                                            children: institutionName
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex gap-8 justify-start items-center text-b2 text-neutral80_to_dark10 font-light",
                                                            children: [
                                                                typeof props?.review_summary?.star_avg === "number" && props?.review_summary?.star_avg !== 0 && !isB2B ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "flex items-center justify-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconStar__WEBPACK_IMPORTED_MODULE_4__/* .IconStar */ .G, {
                                                                                    size: 14,
                                                                                    fill: true,
                                                                                    color: "#EFB443"
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    className: "ml-2 text-b2",
                                                                                    children: (0,lib_helper__WEBPACK_IMPORTED_MODULE_3__/* .formatRating */ .A6)(props?.review_summary?.star_avg.toFixed(1))
                                                                                })
                                                                            ]
                                                                        }),
                                                                        "|"
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                                                props.total_learners !== 0 && !isB2B && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    children: `${(0,lib_helper__WEBPACK_IMPORTED_MODULE_3__/* .numberWithCommas */ .x6)(props.total_learners)} ${t("pelajar").toLowerCase()}`
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: props.tags?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `opacity-100 transition-opacity duration-[1000ms] ease-in-out`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-wrap gap-12 items-center",
                                    children: [
                                        props?.tags?.slice(0, index).map((tag)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_Chip__WEBPACK_IMPORTED_MODULE_6__/* .Chip */ .A, {
                                                className: (isModal ? "bg-light_neutral10_to_dark_neutral50" : "") + " text-neutral80_to_dark10 font-light text-b2",
                                                children: tag || tag.toString()
                                            }, tag.slug)),
                                        lengthOfSkill >= 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-neutral80_to_dark10 text-b2 font-light",
                                            children: [
                                                "+",
                                                lengthOfSkill,
                                                " Skill lainnya"
                                            ]
                                        })
                                    ]
                                })
                            }) : null
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line-clamp-2 text-neutral-70 font-light text-b2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: props?.description
                                }
                            })
                        }),
                        isLoading && chapters.length == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_13__/* .SkeletonRect */ .a8, {
                            className: "w-full h-[76px] rounded-8"
                        }) : !isLoading && chapters.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Accordion_AccordionWithImage__WEBPACK_IMPORTED_MODULE_10__/* .AccordionWithImage */ .H, {
                            className: "bg-slated_purple rounded-8 p-8",
                            data: chapters,
                            countLesson: countLesson
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `
                overflow-hidden flex gap-8 w-full
                ${!isHovering ? "rounded-b-12" : ""} 
                ${isSquare ? "mx-auto px-16" : "m-0"}
              `,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-center items-start",
                                children: institutionImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_LogoChip__WEBPACK_IMPORTED_MODULE_2__/* .LogoChip */ .E, {
                                    image_url: institutionImage,
                                    size: 36,
                                    useResizeImage: true,
                                    styles: "border border-neutral20_to_dark30"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-8 w-[-webkit-fill-available]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                        className: `text-b1 font-medium max-w-full text-neutral-80 text-left ` + (isMyClassPage ? "line-clamp-1" : "line-clamp-2"),
                                        children: [
                                            props.name,
                                            " ",
                                            (tenantJpTracker || isGokAresTenant) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "text-violet_main_to_dark_purple_surface",
                                                children: [
                                                    "(",
                                                    props?.learning_hours,
                                                    " JP)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-b2 font-light max-w-full truncate text-neutral80_to_dark10 text-left",
                                        children: institutionName
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: props.tags?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `opacity-100 transition-opacity duration-[1000ms] ease-in-out`,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-wrap gap-12 items-center",
                                                children: [
                                                    props?.tags?.slice(0, index).map((tag)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_Chip__WEBPACK_IMPORTED_MODULE_6__/* .Chip */ .A, {
                                                            className: (isModal ? "bg-light_neutral10_to_dark_neutral50" : "") + " text-neutral80_to_dark10 font-light text-b2",
                                                            children: tag || tag.toString()
                                                        }, tag.slug)),
                                                    lengthOfSkill >= 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "text-neutral80_to_dark10 text-b2 font-light",
                                                        children: [
                                                            "+",
                                                            lengthOfSkill,
                                                            " Skill lainnya"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }) : null
                                    }),
                                    isMyClass && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col items-center gap-8 py-8",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-full h-6 bg-light_neutral10_to_dark_neutral50 rounded-full overflow-hidden relative",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: `rounded-full h-full ${isCourseFinished ? "bg-green-70" : "bg-violet_main_to_dark_purple_surface"}`,
                                                        style: {
                                                            width: props.enrollment_progress.finished / props.enrollment_progress.total * 100 + "%"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: `w-full flex items-center justify-between text-b2 ${isCourseFinished ? "text-green-70 font-light text-b2" : "text-violet_main_to_dark_purple_surface font-light"}`,
                                                    children: isCourseFinished ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Selesai"
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            props.enrollment_progress?.finished,
                                                            "/",
                                                            t("totalLesson", {
                                                                count: props.enrollment_progress?.total,
                                                                additionalS: props.enrollment_progress?.total > 1 ? "s" : ""
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                props.isChecked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute bg-[#0d0d0d80] top-0 rounded-8 w-full h-full p-8 flex justify-end items-start",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconCheckCircle__WEBPACK_IMPORTED_MODULE_14__/* .IconCheckCircle */ .B, {})
                }) : null
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardCourseWithLesson);


/***/ }),

/***/ 58682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ IconAngle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);

const IconAngle = ({ size =24 , color ="#3E3851" , direction ="left"  })=>{
    let className = "";
    switch(direction){
        case "left":
            className = "rotate-180";
            break;
        case "down":
            className = "rotate-90";
            break;
        case "up":
            className = "-rotate-90";
            break;
        case "right":
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.54 11.29L9.88001 5.64004C9.78705 5.54631 9.67645 5.47191 9.55459 5.42115C9.43273 5.37038 9.30202 5.34424 9.17001 5.34424C9.038 5.34424 8.90729 5.37038 8.78544 5.42115C8.66358 5.47191 8.55298 5.54631 8.46001 5.64004C8.27376 5.8274 8.16922 6.08085 8.16922 6.34504C8.16922 6.60922 8.27376 6.86267 8.46001 7.05004L13.41 12.05L8.46001 17C8.27376 17.1874 8.16922 17.4409 8.16922 17.705C8.16922 17.9692 8.27376 18.2227 8.46001 18.41C8.55263 18.5045 8.66307 18.5797 8.78495 18.6312C8.90682 18.6827 9.03771 18.7095 9.17001 18.71C9.30232 18.7095 9.4332 18.6827 9.55508 18.6312C9.67695 18.5797 9.7874 18.5045 9.88001 18.41L15.54 12.76C15.6415 12.6664 15.7225 12.5527 15.7779 12.4262C15.8333 12.2997 15.8619 12.1631 15.8619 12.025C15.8619 11.8869 15.8333 11.7503 15.7779 11.6238C15.7225 11.4973 15.6415 11.3837 15.54 11.29Z",
            fill: color
        })
    });
};


/***/ }),

/***/ 26178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ IconArrowDown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);

const IconArrowDown = ({ size =20 , fill ="#3E3851" , className =""  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.31689 10.3667L13.0502 6.5667C13.3169 6.30003 13.3169 5.90003 13.0502 5.63336C12.7836 5.3667 12.3836 5.3667 12.1169 5.63336L8.78356 8.90003L5.45023 5.63336C5.18356 5.3667 4.78356 5.3667 4.51689 5.63336C4.38356 5.7667 4.31689 5.90003 4.31689 6.10003C4.31689 6.30003 4.38356 6.43336 4.51689 6.5667L8.25023 10.3667C8.58356 10.6334 8.98356 10.6334 9.31689 10.3667C9.25023 10.3667 9.25023 10.3667 9.31689 10.3667Z",
            fill: fill
        })
    });
};


/***/ }),

/***/ 35445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IconLesson; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);

const IconLesson = ({ size =24 , color ="#3E3851" , type ="Video"  })=>{
    if (type === "Quiz") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M20.0609 23.9981H3.99554C3.24715 23.9981 2.64844 23.3981 2.64844 22.6482V3.44975C2.64844 2.69981 3.24715 2.09985 3.99554 2.09985H20.0609C20.8093 2.09985 21.408 2.69981 21.408 3.44975V22.6482C21.408 23.3481 20.8093 23.9981 20.0609 23.9981Z",
                    fill: "#FACAB3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M20.058 2.04987H8.18359V2.64982C8.18359 2.94979 8.43304 3.19977 8.7324 3.19977H21.4051C21.3053 2.54983 20.7066 2.04987 20.058 2.04987Z",
                    fill: "#F7A983"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.2701 1.54987H14.2224C13.923 1.54987 13.6236 1.34989 13.5239 1.04991C13.3243 0.449962 12.7256 0 12.077 0C11.4284 0 10.8297 0.449962 10.6301 1.04991C10.5303 1.34989 10.231 1.54987 9.93163 1.54987H8.88387C8.53462 1.54987 8.28516 1.84985 8.28516 2.14983V2.94976C8.28516 3.09975 8.38494 3.19974 8.53462 3.19974H15.7191C15.8688 3.19974 15.9686 3.09975 15.9686 2.94976V2.14983C15.8688 1.79985 15.5695 1.54987 15.2701 1.54987ZM12.0271 0.999918C12.3264 0.999918 12.5759 1.2499 12.5759 1.54987H11.4783C11.4783 1.2499 11.7277 0.999918 12.0271 0.999918Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M10.3247 6.59943H7.08165C6.98187 6.59943 6.88208 6.64942 6.83219 6.69942L6.28335 7.24937C6.23346 7.29937 6.18359 7.39936 6.18359 7.49935V11.599C6.18359 11.699 6.23346 11.799 6.28335 11.849L6.83219 12.399C6.88208 12.449 6.98187 12.4989 7.08165 12.4989H10.3247C10.4244 12.4989 10.5242 12.449 10.5741 12.399L11.1229 11.849C11.1728 11.799 11.2227 11.699 11.2227 11.599V7.49935C11.2227 7.39936 11.1728 7.29937 11.1229 7.24937L10.5741 6.69942C10.5242 6.64942 10.4244 6.59943 10.3247 6.59943ZM8.0795 8.0993H9.37669C9.57626 8.0993 9.77583 8.24929 9.77583 8.49927V10.4491L8.92768 9.3992C8.82789 9.29921 8.67821 9.29921 8.57843 9.3492C8.47864 9.44919 8.47862 9.59918 8.52851 9.69918L9.22702 10.5491C9.3767 10.7491 9.22701 10.9991 9.02744 10.9991H8.0795C7.87993 10.9991 7.68037 10.8491 7.68037 10.5991V8.44928C7.68037 8.29929 7.87993 8.0993 8.0795 8.0993Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.8089 7.44934H13.2188V7.9493H17.8089V7.44934Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.8089 8.69925H13.2188V9.19921H17.8089V8.69925Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.8089 9.9491H13.2188V10.4491H17.8089V9.9491Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.6635 11.1991H13.2188V11.6991H15.6635V11.1991Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.88945 23.8982C7.58983 23.8982 9.77891 21.7045 9.77891 18.9986C9.77891 16.2926 7.58983 14.099 4.88945 14.099C2.18908 14.099 0 16.2926 0 18.9986C0 21.7045 2.18908 23.8982 4.88945 23.8982Z",
                    fill: "#551FC1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M19.1082 23.8982C21.8086 23.8982 23.9977 21.7045 23.9977 18.9986C23.9977 16.2926 21.8086 14.099 19.1082 14.099C16.4078 14.099 14.2188 16.2926 14.2188 18.9986C14.2188 21.7045 16.4078 23.8982 19.1082 23.8982Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M18.2115 20.6483L17.8623 20.2984C17.7126 20.1484 17.7126 19.9484 17.8623 19.7984L20.307 17.3486C20.4567 17.1986 20.6562 17.1986 20.8059 17.3486L21.1552 17.6986C21.3049 17.8486 21.3049 18.0486 21.1552 18.1985L18.7104 20.6483C18.5608 20.7483 18.3612 20.7483 18.2115 20.6483Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.1162 19.0485L17.4654 18.6985C17.6151 18.5485 17.8147 18.5485 17.9643 18.6985L19.062 19.7984C19.2117 19.9484 19.2117 20.1484 19.062 20.2984L18.7127 20.6483C18.5631 20.7983 18.3635 20.7983 18.2138 20.6483L17.1162 19.5484C16.9665 19.3984 16.9665 19.1485 17.1162 19.0485Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M3.64511 20.6484L3.29585 20.2984C3.14617 20.1484 3.14617 19.9484 3.29585 19.7984L5.74059 17.3486C5.89027 17.1986 6.08984 17.1986 6.23952 17.3486L6.58877 17.6986C6.73845 17.8486 6.73845 18.0486 6.58877 18.1986L4.14403 20.6484C3.99435 20.7484 3.79478 20.7484 3.64511 20.6484Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M3.2389 17.6986L3.58815 17.3486C3.73783 17.1986 3.9374 17.1986 4.08708 17.3486L6.53179 19.7984C6.68147 19.9484 6.68147 20.1484 6.53179 20.2984L6.18257 20.6483C6.03289 20.7983 5.83332 20.7983 5.68364 20.6483L3.2389 18.1985C3.13912 18.0486 3.13912 17.8486 3.2389 17.6986Z",
                    fill: "white"
                })
            ]
        });
    } else if (type === "Article") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "24",
            height: "22",
            viewBox: "0 0 24 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M11.9961 22L0.345093 18.4549C0.138093 18.3916 -0.00390625 18.2014 -0.00390625 17.9854V0.491298C-0.00390625 0.142264 0.351598 -0.0952405 0.675598 0.0372035L11.9961 4.65581V22Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M11.9961 22L23.6471 18.4549C23.8541 18.3916 23.9961 18.2014 23.9961 17.9854V0.491298C23.9961 0.142264 23.6406 -0.0952405 23.3166 0.0372035L11.9961 4.65581V22Z",
                    fill: "#F7A983"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M21.2699 7.33803L14.7344 9.66676V8.85765L21.2699 6.52893V7.33803Z",
                    fill: "#FACAB3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M21.2699 10.2374L14.7344 12.4003V11.5912L21.2699 9.42828V10.2374Z",
                    fill: "#FACAB3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M21.2699 12.9963L14.7344 15.1334V14.3243L21.2699 12.1872V12.9963Z",
                    fill: "#FACAB3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9.99609 21.3916L11.9961 22V4.65634L9.99609 3.84027V21.3916Z",
                    fill: "#551FC1"
                })
            ]
        });
    } else if (type === "Assignment") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "20",
            height: "24",
            viewBox: "0 0 20 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.161 0C18.7074 0 19.9961 1.2 19.9961 2.75V21.25C19.9961 22.75 18.759 24 17.161 24H2.83114C1.28475 24 -0.00390625 22.8 -0.00390625 21.25V5.89999C-0.00390625 5.54999 0.150739 5.25 0.356924 5.05L5.20229 0.350006C5.46002 0.100006 5.76931 0 6.07859 0H17.161V0Z",
                    fill: "#FACAB3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5.25383 0.350037C5.35692 0.250037 5.51156 0.150037 5.61466 0.100037V2.85004C5.61466 4.85004 3.96517 6.45003 1.90331 6.45003H-0.00390625V5.95003C-0.00390625 5.60003 0.150739 5.30004 0.356924 5.10004L5.25383 0.350037Z",
                    fill: "#F7A983"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M0.148438 5.45003C0.199984 5.30003 0.303076 5.20004 0.406169 5.10004L5.25151 0.400024C5.3546 0.300024 5.50924 0.200024 5.61234 0.150024V2.75003C5.61234 4.25003 4.37522 5.50003 2.77729 5.50003H0.148438V5.45003Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5.92451 9.25003H4.79052C4.58433 9.25003 4.42969 9.10002 4.42969 8.90002V8.25003C4.42969 8.05003 4.58433 7.90002 4.79052 7.90002H5.92451C6.1307 7.90002 6.28534 8.05003 6.28534 8.25003V8.85004C6.28534 9.10004 6.1307 9.25003 5.92451 9.25003Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.1984 9.25003H7.98189C7.77571 9.25003 7.62109 9.10002 7.62109 8.90002V8.25003C7.62109 8.05003 7.77571 7.90002 7.98189 7.90002H15.1984C15.4046 7.90002 15.5592 8.05003 15.5592 8.25003V8.85004C15.5592 9.10004 15.4046 9.25003 15.1984 9.25003Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5.92451 12.2H4.79052C4.58433 12.2 4.42969 12.05 4.42969 11.85V11.25C4.42969 11.05 4.58433 10.9 4.79052 10.9H5.92451C6.1307 10.9 6.28534 11.05 6.28534 11.25V11.85C6.28534 12.05 6.1307 12.2 5.92451 12.2Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.1984 12.2H7.98189C7.77571 12.2 7.62109 12.05 7.62109 11.85V11.25C7.62109 11.05 7.77571 10.9 7.98189 10.9H15.1984C15.4046 10.9 15.5592 11.05 15.5592 11.25V11.85C15.5592 12.05 15.4046 12.2 15.1984 12.2Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5.92451 15.2H4.79052C4.58433 15.2 4.42969 15.05 4.42969 14.85V14.25C4.42969 14.05 4.58433 13.9 4.79052 13.9H5.92451C6.1307 13.9 6.28534 14.05 6.28534 14.25V14.85C6.28534 15.05 6.1307 15.2 5.92451 15.2Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.1984 15.2H7.98189C7.77571 15.2 7.62109 15.05 7.62109 14.85V14.25C7.62109 14.05 7.77571 13.9 7.98189 13.9H15.1984C15.4046 13.9 15.5592 14.05 15.5592 14.25V14.85C15.5592 15.05 15.4046 15.2 15.1984 15.2Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5.92451 18.2H4.79052C4.58433 18.2 4.42969 18.05 4.42969 17.85V17.25C4.42969 17.05 4.58433 16.9 4.79052 16.9H5.92451C6.1307 16.9 6.28534 17.05 6.28534 17.25V17.85C6.28534 18.05 6.1307 18.2 5.92451 18.2Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.1984 18.2H7.98189C7.77571 18.2 7.62109 18.05 7.62109 17.85V17.25C7.62109 17.05 7.77571 16.9 7.98189 16.9H15.1984C15.4046 16.9 15.5592 17.05 15.5592 17.25V17.85C15.5592 18.05 15.4046 18.2 15.1984 18.2Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.9326 12.3C17.9326 12.25 17.9326 12.15 17.8811 12.1C17.7264 11.55 17.2625 11.1 16.6955 10.95C16.1285 10.8 15.5099 10.95 15.0976 11.35L8.60271 17.65C8.19034 18.05 7.82953 18.55 7.52025 19.05V19.1C7.41716 19.3 7.26251 19.55 7.15942 19.8L6.48932 21.5C6.38623 21.75 6.54086 22 6.79859 22.05C6.85014 22.05 6.90169 22.05 6.90169 22.05C6.95324 22.05 7.00479 22.05 7.00479 22L8.13881 21.6L8.75734 21.35C9.01508 21.25 9.22127 21.15 9.47901 21H9.53054C10.046 20.7 10.5099 20.4 10.9739 19.95L15.8192 15.25L17.4687 13.65C17.7264 13.4 17.8811 13.05 17.9326 12.7C17.9326 12.65 17.9326 12.55 17.9326 12.5C17.9326 12.45 17.9326 12.4 17.9326 12.3Z",
                    fill: "#7447CC"
                })
            ]
        });
    } else if (type === "PDF") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "21",
            height: "24",
            viewBox: "0 0 21 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.5595 0C19.1059 0 20.3945 1.2 20.3945 2.75V21.25C20.3945 22.75 19.1574 24 17.5595 24H3.22958C1.68319 24 0.394531 22.8 0.394531 21.25V5.89999C0.394531 5.54999 0.549161 5.24999 0.755347 5.04999L5.60072 0.350006C5.85845 0.100006 6.16772 0 6.477 0H17.5595V0Z",
                    fill: "#FACAB3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5.65226 0.350037C5.75535 0.250037 5.90999 0.150037 6.01309 0.100037V2.85004C6.01309 4.85004 4.3636 6.45004 2.30174 6.45004H0.394531V5.95004C0.394531 5.60004 0.549161 5.30004 0.755347 5.10004L5.65226 0.350037Z",
                    fill: "#F7A983"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M0.546875 5.45004C0.598421 5.30004 0.701514 5.20004 0.804607 5.10004L5.64997 0.400024C5.75306 0.300024 5.9077 0.200024 6.0108 0.150024V2.75003C6.0108 4.25003 4.77368 5.50003 3.17574 5.50003H0.546875V5.45004Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.69137 12.45C8.69137 12.85 8.58827 13.15 8.33054 13.35C8.07281 13.55 7.76353 13.7 7.29961 13.7H7.04188V14.9H6.0625V11.35H7.35116C7.81508 11.35 8.1759 11.45 8.38209 11.65C8.58827 11.85 8.69137 12.1 8.69137 12.45ZM6.99033 12.95H7.19651C7.35115 12.95 7.45425 12.9 7.55734 12.85C7.66044 12.75 7.71198 12.65 7.71198 12.5C7.71198 12.25 7.55734 12.15 7.29961 12.15H7.04188V12.95H6.99033Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12.2459 13.05C12.2459 13.65 12.0913 14.1 11.7304 14.45C11.3696 14.75 10.9057 14.95 10.2871 14.95H9.10156V11.4H10.3902C10.9572 11.4 11.4212 11.55 11.782 11.85C12.0913 12.05 12.2459 12.5 12.2459 13.05ZM11.215 13.1C11.215 12.75 11.1634 12.55 11.0088 12.35C10.8541 12.2 10.648 12.1 10.3902 12.1H10.0809V14.1H10.2871C10.5964 14.1 10.8026 14 10.9572 13.85C11.1634 13.7 11.215 13.45 11.215 13.1Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M13.7958 14.9H12.8164V11.35H14.9813V12.1H13.7958V12.8H14.8783V13.55H13.7958V14.9Z",
                    fill: "#7447CC"
                })
            ]
        });
    } else if (type === "IFrame") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "25",
            height: "20",
            viewBox: "0 0 25 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M22.743 20H2.84296C1.69296 20 0.792969 19.1262 0.792969 18.0097V2.03883C0.792969 0.922327 1.69296 0.0485229 2.84296 0.0485229H22.743C23.893 0.0485229 24.793 0.922327 24.793 2.03883V18.0097C24.793 19.0776 23.893 20 22.743 20Z",
                    fill: "#FACAB3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M22.743 0H2.84296C1.69296 0 0.792969 0.873774 0.792969 1.99028V2.91262H24.793V1.99028C24.793 0.922318 23.893 0 22.743 0Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M3.74451 1.16498H3.14453V1.74751H3.74451V1.16498Z",
                    fill: "#551FC1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.99451 1.16498H4.39453V1.74751H4.99451V1.16498Z",
                    fill: "#551FC1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.24451 1.16498H5.64453V1.74751H6.24451V1.16498Z",
                    fill: "#551FC1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M24.793 2.9126H0.792969V3.20385H24.793V2.9126Z",
                    fill: "#551FC1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M24.793 4.6116H2.19296C1.44296 4.6116 0.792969 4.02908 0.792969 3.25238H24.793V4.6116Z",
                    fill: "#F7A983"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9.50232 15.2913C9.20232 15.2913 8.90232 15.1457 8.75232 14.903L5.90234 11.3107L8.75232 7.7185C9.10232 7.33015 9.70233 7.23308 10.1023 7.52434C10.5023 7.86414 10.6023 8.44668 10.3023 8.83502L8.35233 11.3107L10.3023 13.7865C10.6523 14.1748 10.5523 14.8059 10.1023 15.0971C9.90233 15.1942 9.70232 15.2913 9.50232 15.2913Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M16.1003 15.2913C15.9003 15.2913 15.7003 15.2427 15.5003 15.0971C15.1003 14.7573 15.0003 14.1748 15.3003 13.7864L17.2503 11.3107L15.3003 8.83497C14.9503 8.44662 15.0503 7.81555 15.5003 7.52429C15.9003 7.18448 16.5503 7.28155 16.8503 7.71845L19.7003 11.3107L16.8503 14.9029C16.7003 15.1457 16.4003 15.2913 16.1003 15.2913Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12.1444 14.9515C12.0944 14.9515 12.0944 14.9515 12.0444 14.9515C11.7944 14.903 11.5944 14.6603 11.6444 14.4175L12.8944 8.10686C12.9444 7.86414 13.1944 7.66994 13.4444 7.71849C13.6944 7.76703 13.8944 8.00977 13.8444 8.25248L12.5944 14.5632C12.5944 14.7573 12.3944 14.9515 12.1444 14.9515Z",
                    fill: "#7447CC"
                })
            ]
        });
    } else if (type === "Webinar") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "25",
            height: "24",
            viewBox: "0 0 25 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.8884 23.9954H18.9882L16.5886 12.4977H15.4389L16.6386 18.2465H8.99015L10.1899 12.4977H9.09014L6.64062 23.9954H7.7404L8.84019 18.8964H16.7886L17.8884 23.9954Z",
                    fill: "#551FC1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M14.3385 0.899831H11.2891V0.799844C11.2891 0.349934 11.639 0 12.0889 0H13.5386C13.9885 0 14.3385 0.349934 14.3385 0.799844V0.899831Z",
                    fill: "#551FC1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M23.2887 14.5971H2.39281C1.9429 14.5971 1.54297 14.1972 1.54297 13.7473V2.69946H24.1385V13.7473C24.1385 14.2472 23.7386 14.5971 23.2887 14.5971Z",
                    fill: "#FACAB3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M24.0384 2.69956H1.54282C1.1429 2.69956 0.792969 2.34963 0.792969 1.94971V1.39981C0.792969 0.999894 1.1429 0.649963 1.54282 0.649963H24.0384C24.4383 0.649963 24.7882 0.999894 24.7882 1.39981V1.94971C24.8382 2.34963 24.4883 2.69956 24.0384 2.69956Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M24.1385 2.69946H1.54297V3.34933H24.1385V2.69946Z",
                    fill: "#F7A983"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.29237 9.29821V8.64834C8.29237 8.09845 7.99243 7.64854 7.54252 7.3486C7.09261 7.09865 6.54272 7.09865 6.04282 7.3486C5.59291 7.59855 5.29297 8.09845 5.29297 8.64834V9.29821C5.29297 9.74812 5.54291 10.198 5.94283 10.398C6.44273 10.6979 7.09261 10.6979 7.59252 10.398C8.04243 10.198 8.29237 9.79811 8.29237 9.29821Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M10.0425 15.347H3.59375V14.2972C3.59375 12.4976 5.04346 11.0479 6.84311 11.0479C8.64275 11.0479 10.0925 12.4976 10.0925 14.2972V15.347H10.0425Z",
                    fill: "#7447CC"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12.2415 16.9967H1.39364C1.0937 16.9967 0.84375 16.7468 0.84375 16.4468V15.9469C0.84375 15.647 1.0937 15.397 1.39364 15.397H12.2415C12.5414 15.397 12.7914 15.647 12.7914 15.9469V16.4468C12.8414 16.7468 12.5414 16.9967 12.2415 16.9967Z",
                    fill: "#551FC1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12.1401 16.9967H1.49219V23.9953H12.1401V16.9967Z",
                    fill: "#551FC1"
                })
            ]
        });
    }
};


/***/ }),

/***/ 820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useModalSectionStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);

const useModalSectionStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // state
        title: "",
        isShow: false,
        isShowBundle: false,
        isLoading: true,
        data: [],
        // actions
        setSelectedTitle (item) {
            set({
                title: item
            });
        },
        setIsShow (item) {
            set({
                isShow: item
            });
        },
        setIsShowBundle (item) {
            set({
                isShowBundle: item
            });
        },
        setDataSection (item) {
            set({
                data: item
            });
        },
        setLoading (item) {
            set({
                isLoading: item
            });
        }
    }));


/***/ })

}]);